// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const projectCompanyTypeSchema = z.enum(['no-customer', 'customer']);

export type ProjectCompanyType = z.infer<typeof projectCompanyTypeSchema>;
